import React from 'react'
import { ArrowLongRightIcon } from '@heroicons/react/20/solid'

interface CardProps {
  title?: string
  children?: React.ReactNode
}

const Card: React.FC<CardProps> = ({ title, children, ...props }) => {
  return (
    <div
      {...props}
      className='
        group cursor-pointer w-full h-full will-change-transform flex flex-col gap-10 items-center text-center
        transition duration-500 text-[var(--loan-type-text)] rounded-[4px] bg-[var(--loan-type-bg)] px-7 py-6
        [@media(hover:hover)]:hover:bg-[var(--loan-type-bg-hover)] [@media(hover:hover)]:hover:text-[var(--loan-type-text-hover)] [@media(hover:hover)]:hover:scale-[1.1]
    '>
      { children && 
        <div className='size-[124px] flex items-center transition duration-500 justify-center bg-[var(--loan-type-icon-bg)] mx-auto rounded-full text-[var(--loan-type-icon)] [@media(hover:hover)]:group-hover:text-[var(--loan-type-icon-hover)] [@media(hover:hover)]:group-hover:bg-[var(--loan-type-icon-bg-hover)]'>
          {children}
        </div>
      }
      <span className='flex flex-col items-center gap-1'>
        <span className='text-xl font-[var(--font-weight-bold)] text-balance px-0.5'>{title}</span>
        <ArrowLongRightIcon aria-hidden='true' className='size-7' />
      </span>
    </div>
  )
}

export {Card}